















































































import { cloneDeep } from 'lodash'
import { Component, Prop, Watch } from 'vue-property-decorator'

import DrawerWidthMixin from '../../../../../../../../../logic/helpers/DrawerWidthMixin'
import BlockMovingControls from '../../../../../../../../BlockMovingControls/BlockMovingControls.vue'
import BaseCondition from '../../logic/ConditionTypes/BaseCondition'
import { ConditionsNode } from '../../logic/ConditionsNode'
import ConditionEditor from './ConditionEditor/ConditionEditor.vue'
import SidebarConditionView from './ConditionView/SidebarConditionView.vue'

@Component({
  components: {
    BlockMovingControls,
    ConditionEditor,
    SidebarConditionView,
  }
})
export default class ConditionsNodeSidebar extends DrawerWidthMixin {
  @Prop() node!: ConditionsNode

  @Watch('isOpen')
  isOpenWatcher(val: boolean): void {
    if (!val) {
      this.newCondition = null
      this.selectedGroup = null

      this.selectedCondition = null
    }
  }

  newCondition: BaseCondition | null = null

  isOpen = false

  selectedGroup: string | null = null

  selectedCondition: string | null = null

  selectGroup(guid: string): void {
    this.selectedGroup = guid
    this.isOpen = true
  }

  selectCondition(condition: BaseCondition, groupGuid: string): void {
    this.selectedGroup = groupGuid
    this.selectedCondition = condition.guid

    this.newCondition = cloneDeep(condition)
    this.isOpen = true
  }

  setCondition(): void {
    if (this.newCondition) {
      if (this.selectedGroup && this.selectedCondition) {
        this.node.spliceCondition(this.newCondition, this.selectedCondition, this.selectedGroup)
      } else {
        this.node.setCondition(this.newCondition, this.selectedGroup ?? undefined)
      }

      this.isOpen = false
    }
  }
}
